/**
 * Groundcover Leather â€” Sizing Guide
 * File: assets/sizing-guide.js
 *
 * â”€â”€â”€ HOW TO EDIT SIZE DATA â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
 *
 * All size data lives in the SIZING_DATA object below.
 * Structure: SIZING_DATA[gender][category][itemName]
 *
 * Each item has:
 *   image â€” full URL to the product thumbnail (optional but recommended).
 *           Use the file URL from Shopify admin â†’ Content â†’ Files.
 *           Right-click any uploaded image there and "Copy link" â€” paste
 *           that full https:// URL in here. Square images work best since
 *           thumbnails are cropped to a square.
 *   rows  â€” array of [Shoe Size, Width (mm), Length (mm)] for that item.
 *           All tables use this same 3-column format â€” do not change cols
 *           per item, only the row values.
 *   note  â€” fitting tip shown below the table (optional)
 *
 * â”€â”€â”€ DEEP-LINK URL FORMAT â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
 *
 * To link directly to a sizing table from any page, append these params:
 *   ?sg_gender=mens&sg_category=Boots&sg_item=Chelsea+Boot
 *
 * â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
 */

const SG_COLS = ["Shoe Size", "Width (mm)", "Length (mm)"];

const SIZING_DATA = {
  mens: {
    label: "Men's",
    categories: {
      Boots: {
        "Berg Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Berg-Brown_800x800_a.jpg?v=1740804423&width=600",
          rows: [
            ["3", "84", "222"],
            ["3.5", "86", "228"],
            ["4", "87", "233"],
            ["4.5", "89", "237"],
            ["5", "91", "241"],
            ["5.5", "91", "243"],
            ["6", "91", "249"],
            ["6.5", "91", "251"],
            ["7", "93", "257"],
            ["7.5", "94", "261"],
            ["8", "96", "266"],
            ["8.5", "96", "271"],
            ["9", "98", "274"],
            ["9.5", "98", "278"],
            ["10", "100", "281"],
            ["10.5", "101", "286"],
            ["11", "102", "291"],
            ["11.5", "102", "294"],
            ["12", "102", "299"],
            ["13", "102", "307"]
          ],
          note: "Berg Boot, Karkloof, Chelsea, Trekker"
        },
        "Sabie Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Sabie-boot_800x800_f368f93b-a150-4fb2-b290-7bdfdfe7799a.jpg?v=1778072974&width=600",
          rows: [
            ["4", "86", "230"],
            ["4.5", "87", "234"],
            ["5", "88", "238"],
            ["5.5", "89", "242"],
            ["6", "90", "248"],
            ["6.5", "91", "250"],
            ["7", "92", "256"],
            ["7.5", "94", "259"],
            ["8", "95", "263"],
            ["8.5", "95", "268"],
            ["9", "96", "273"],
            ["9.5", "97", "277"],
            ["10", "97", "281"],
            ["10.5", "98", "285"],
            ["11", "100", "289"],
            ["11.5", "102", "294"],
            ["12", "103", "299"],
            ["13", "105", "307"]
          ],
          note: "Bikers, Desert, M. Combat, Sabie"
        },
        "Thuli Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Thuli-OilyBrown_800x800_a.jpg?v=1740804426&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Chelsea Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Chelsea-Black_800x800_a_377214b5-16e4-4ab5-832c-0c8fc1a7e1a3.jpg?v=1778835967&width=600",
          rows: [
            ["3", "84", "222"],
            ["3.5", "80", "226"],
            ["4", "87", "233"],
            ["4.5", "89", "237"],
            ["5", "91", "241"],
            ["5.5", "91", "243"],
            ["6", "91", "249"],
            ["6.5", "91", "251"],
            ["7", "93", "257"],
            ["7.5", "94", "261"],
            ["8", "96", "266"],
            ["8.5", "96", "271"],
            ["9", "98", "274"],
            ["9.5", "98", "278"],
            ["10", "100", "281"],
            ["10.5", "101", "286"],
            ["11", "102", "291"],
            ["11.5", "102", "294"],
            ["12", "102", "299"],
            ["13", "102", "307"]
          ],
          note: "Berg Boot, Karkloof, Chelsea, Trekker"
        },
        "Chelsea Steel Toe": {
          image: "https://groundcover.co.za/cdn/shop/files/Chelsea-Boot---Black-Steel-Toe-Cap_800x800_a.jpg?v=1740804397&width=600",
          rows: [
            ["5", "88", "238"],
            ["6", "90", "246"],
            ["7", "92", "255"],
            ["8", "93", "263"],
            ["9", "98", "271"],
            ["10", "98", "279"],
            ["11", "100", "289"],
            ["12", "103", "296"]
          ],
          note: "Forester, Chelsea Steel, Trekker Steel"
        },
        "Trekker Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Trekker-Boot-Tan_800x800_a.jpg?v=1740804408&width=600",
          rows: [
            ["3", "84", "222"],
            ["3.5", "86", "228"],
            ["4", "87", "233"],
            ["4.5", "89", "237"],
            ["5", "91", "241"],
            ["5.5", "91", "243"],
            ["6", "91", "249"],
            ["6.5", "91", "251"],
            ["7", "93", "257"],
            ["7.5", "94", "261"],
            ["8", "96", "266"],
            ["8.5", "96", "271"],
            ["9", "98", "274"],
            ["9.5", "98", "278"],
            ["10", "100", "281"],
            ["10.5", "101", "286"],
            ["11", "102", "291"],
            ["11.5", "102", "294"],
            ["12", "102", "299"],
            ["13", "102", "307"]
          ],
          note: "Berg Boot, Karkloof, Chelsea, Trekker"
        },
        "Trekker Steel Toe": {
          image: "https://groundcover.co.za/cdn/shop/files/Trekker-Boot-Steel-Toe-Cap-Brown_800x800_a.jpg?v=1740804391&width=600",
          rows: [
            ["5", "88", "238"],
            ["6", "90", "246"],
            ["7", "92", "255"],
            ["8", "93", "263"],
            ["9", "98", "271"],
            ["10", "98", "279"],
            ["11", "100", "289"],
            ["12", "103", "296"]
          ],
          note: "Forester, Chelsea Steel, Trekker Steel"
        },
        "Land Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Land-Tan_800x800_a.jpg?v=1740804412&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"],
            ["6.5", "93", "256"],
            ["7", "95", "258"],
            ["7.5", "95", "264"],
            ["8", "95", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "279"],
            ["9.5", "98", "282"],
            ["10", "102", "286"],
            ["10.5", "102", "289"],
            ["11", "104", "294"],
            ["11.5", "107", "299"],
            ["12", "109", "304"],
            ["13", "110", "311"],
            ["14", "110", "319"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Karkloof Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Karkloof-Brown_800x800_a.jpg?v=1740804401&width=600",
          rows: [
            ["3", "84", "222"],
            ["3.5", "84", "230"],
            ["4", "87", "233"],
            ["4.5", "89", "237"],
            ["5", "91", "241"],
            ["5.5", "91", "243"],
            ["6", "91", "249"],
            ["6.5", "91", "251"],
            ["7", "93", "257"],
            ["7.5", "94", "261"],
            ["8", "96", "266"],
            ["8.5", "96", "271"],
            ["9", "98", "274"],
            ["9.5", "98", "278"],
            ["10", "100", "281"],
            ["10.5", "101", "286"],
            ["11", "102", "291"],
            ["11.5", "102", "294"],
            ["12", "102", "299"],
            ["13", "102", "307"]
          ],
          note: "Berg Boot, Karkloof, Chelsea, Trekker"
        },
        "Dirt Road Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Dirt-Road---Chestnut_800x800_a.jpg?v=1740804409&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"],
            ["6.5", "93", "256"],
            ["7", "95", "258"],
            ["7.5", "95", "264"],
            ["8", "95", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "279"],
            ["9.5", "98", "282"],
            ["10", "102", "286"],
            ["10.5", "102", "289"],
            ["11", "104", "294"],
            ["11.5", "107", "299"],
            ["12", "109", "304"],
            ["13", "110", "311"],
            ["14", "110", "319"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Stockman Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Stockman-Oily-Brown_800x800_a.jpg?v=1740804398&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"],
            ["6.5", "93", "256"],
            ["7", "95", "258"],
            ["7.5", "95", "264"],
            ["8", "95", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "279"],
            ["9.5", "98", "282"],
            ["10", "102", "286"],
            ["10.5", "102", "289"],
            ["11", "104", "294"],
            ["11.5", "107", "299"],
            ["12", "109", "304"],
            ["13", "110", "311"],
            ["14", "110", "319"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Desert Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Desert-Tan_800x800_a.jpg?v=1740804405&width=600",
          rows: [
            ["4", "86", "230"],
            ["4.5", "87", "234"],
            ["5", "88", "238"],
            ["5.5", "89", "242"],
            ["6", "90", "248"],
            ["6.5", "91", "250"],
            ["7", "92", "256"],
            ["7.5", "94", "259"],
            ["8", "95", "263"],
            ["8.5", "95", "268"],
            ["9", "96", "273"],
            ["9.5", "97", "277"],
            ["10", "97", "281"],
            ["10.5", "98", "285"],
            ["11", "100", "289"],
            ["11.5", "102", "294"],
            ["12", "103", "299"],
            ["13", "105", "307"]
          ],
          note: "Bikers, Desert, M. Combat, Sabie"
        },
        "Veldskoen Broad Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Suede-FS-Khaki_800x800_a.jpg?v=1740804416&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen FS, Walking FS"
        },
        "Veldskoen Slim Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/slim-fit-Khaki-Veldskoen_800x800_a.jpg?v=1740804388&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Traditional Veldskoen": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Traditional-Brown_800x800_a.jpg?v=1740804414&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"],
            ["6.5", "93", "256"],
            ["7", "95", "258"],
            ["7.5", "95", "264"],
            ["8", "95", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "279"],
            ["9.5", "98", "282"],
            ["10", "102", "286"],
            ["10.5", "102", "289"],
            ["11", "104", "294"],
            ["11.5", "107", "299"],
            ["12", "109", "304"],
            ["13", "110", "311"],
            ["14", "110", "319"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Veldskoen FS - Full Grain": {
          image: "https://groundcover.co.za/cdn/shop/files/GC_800x800_Full-grain-veliie_b.jpg?v=1778754632&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen FS, Walking FS"
        },
        "Combat Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Combat-Boot-Brown_800x800_a.jpg?v=1740804403&width=600",
          rows: [
            ["4", "86", "230"],
            ["4.5", "87", "234"],
            ["5", "88", "238"],
            ["5.5", "89", "242"],
            ["6", "90", "248"],
            ["6.5", "91", "250"],
            ["7", "92", "256"],
            ["7.5", "94", "259"],
            ["8", "95", "263"],
            ["8.5", "95", "268"],
            ["9", "96", "273"],
            ["9.5", "97", "277"],
            ["10", "97", "281"],
            ["10.5", "98", "285"],
            ["11", "100", "289"],
            ["11.5", "102", "294"],
            ["12", "103", "299"],
            ["13", "105", "307"]
          ],
          note: "Bikers, Desert, M. Combat, Sabie"
        },
        "Biker Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Bikers-black_800x800_a.jpg?v=1740804394&width=600",
          rows: [
            ["4", "86", "230"],
            ["4.5", "87", "234"],
            ["5", "88", "238"],
            ["5.5", "89", "242"],
            ["6", "90", "248"],
            ["6.5", "91", "250"],
            ["7", "92", "256"],
            ["7.5", "94", "259"],
            ["8", "95", "263"],
            ["8.5", "95", "268"],
            ["9", "96", "273"],
            ["9.5", "97", "277"],
            ["10", "97", "281"],
            ["10.5", "98", "285"],
            ["11", "100", "289"],
            ["11.5", "102", "294"],
            ["12", "103", "299"],
            ["13", "105", "307"]
          ],
          note: "Bikers, Desert, M. Combat, Sabie"
        },
        "Forrester Boot - Steel Toe": {
          image: "https://groundcover.co.za/cdn/shop/files/Forrester-steel-toe-cap-Brown_800x800_a.jpg?v=1740804395&width=600",
          rows: [
            ["5", "88", "238"],
            ["6", "90", "246"],
            ["7", "92", "255"],
            ["8", "93", "263"],
            ["9", "98", "271"],
            ["10", "98", "279"],
            ["11", "100", "289"],
            ["12", "103", "296"]
          ],
          note: "Forester, Chelsea Steel, Trekker Steel"
        },
        "Wool Blizzard Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Blizzard-Boot-Brown_800x800_a.jpg?v=1740804418&width=600",
          rows: [
            ["4", "82", "234"],
            ["4.5", "82", "239"],
            ["5", "87", "243"],
            ["5.5", "87", "248"],
            ["6", "88", "252"],
            ["6.5", "88", "256"],
            ["7", "89", "259"],
            ["7.5", "89", "263"],
            ["8", "91", "269"],
            ["8.5", "92", "273"],
            ["9", "93", "277"],
            ["9.5", "94", "281"],
            ["10", "94", "286"],
            ["10.5", "96", "290"],
            ["11", "97", "294"],
            ["12", "101", "300"],
            ["13", "102", "311"]
          ],
          note: "Wool Blizzard Boot"
        },
        "Wool Tundra Nguni": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-NguniB_W_800x800_a.jpg?v=1740804393&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Wool Tundra": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-Brown_800x800_a.jpg?v=1740804335&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Wool Winter Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Winer-Boot_800x800_a_85a2de32-4e66-4e93-99f8-99528e7ae7a7.jpg?v=1740804338&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool High Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-High-Boot-Tan-NB_800x800_a.jpg?v=1740804421&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Ankle Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Ankle-Boot-Adult-TanNB_800x800_a.jpg?v=1740804419&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Fold-Down Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Fold-down--Tan-NB_800x800_a.jpg?v=1740804400&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Oliver Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Oliver-Black_800x800_a.jpg?v=1740803988&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        }
      },
      Shoes: {
        "Clog Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Clog-Tan_800x800_a.jpg?v=1740804006&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Slip-on Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Slip-on-Black_800x800_a.jpg?v=1740804383&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Navajo, M.Slip-on, Strutter, Wool Tundra"
        },
        "Walking Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/WalkingShoe-Chestnut_Green_800x800_a.jpg?v=1740804385&width=600",
          rows: [
            ["2", "80", "216"],
            ["2.5", "81", "221"],
            ["3", "81", "224"],
            ["3.5", "82", "230"],
            ["4", "84", "233"],
            ["4.5", "86", "238"],
            ["5", "86", "242"],
            ["5.5", "87", "246"],
            ["6", "86", "250"],
            ["6.5", "89", "253"],
            ["7", "91", "259"],
            ["7.5", "92", "263"],
            ["8", "93", "267"],
            ["8.5", "94", "271"],
            ["9", "96", "275"],
            ["9.5", "96", "279"],
            ["10", "98", "284"],
            ["10.5", "98", "288"],
            ["11", "98", "293"],
            ["11.5", "102", "298"],
            ["12", "102", "301"],
            ["13", "103", "310"]
          ],
          note: "Oxford, Walking"
        },
        "Oxford Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Oxford-Black_800x800_a.jpg?v=1740804381&width=600",
          rows: [
            ["2", "80", "216"],
            ["2.5", "81", "221"],
            ["3", "81", "224"],
            ["3.5", "82", "230"],
            ["4", "84", "233"],
            ["4.5", "86", "238"],
            ["5", "86", "242"],
            ["5.5", "87", "246"],
            ["6", "86", "250"],
            ["6.5", "89", "253"],
            ["7", "91", "259"],
            ["7.5", "92", "263"],
            ["8", "93", "267"],
            ["8.5", "94", "271"],
            ["9", "96", "275"],
            ["9.5", "96", "279"],
            ["10", "98", "284"],
            ["10.5", "98", "288"],
            ["11", "98", "293"],
            ["11.5", "102", "298"],
            ["12", "102", "301"],
            ["13", "103", "310"]
          ],
          note: "Oxford, Walking"
        },
        "Broad Walking Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/WalkingShoeFS-Chestnut_800x800_a.jpg?v=1740804373&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen FS, Walking FS"
        },
        "Trekker Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Trekker-Shoe-Tan_800x800_a.jpg?v=1740804379&width=600",
          rows: [
            ["3", "84", "222"],
            ["4", "87", "233"],
            ["4.5", "89", "237"],
            ["5", "91", "241"],
            ["5.5", "91", "243"],
            ["6", "91", "249"],
            ["6.5", "91", "251"],
            ["7", "93", "257"],
            ["7.5", "94", "261"],
            ["8", "96", "266"],
            ["8.5", "96", "271"],
            ["9", "98", "274"],
            ["9.5", "98", "278"],
            ["10", "100", "281"],
            ["10.5", "101", "286"],
            ["11", "102", "291"],
            ["11.5", "102", "294"],
            ["12", "102", "299"],
            ["13", "102", "307"]
          ],
          note: "Berg Boot, Karkloof, Chelsea, Trekker"
        },
        "Boat Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Boat-Tan_Navy_800x800_a.jpg?v=1740804377&width=600",
          rows: [
            ["3", "83", "227"],
            ["4", "86", "235"],
            ["5", "88", "244"],
            ["6", "91", "248"],
            ["7", "94", "260"],
            ["8", "96", "269"],
            ["9", "98", "278"],
            ["10", "98", "286"],
            ["11", "100", "294"],
            ["12", "103", "304"]
          ],
          note: "Boat, Loafer"
        },
        "Loafer Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Loafer-Brown_800x800_a.jpg?v=1740804375&width=600",
          rows: [
            ["3", "83", "227"],
            ["4", "86", "235"],
            ["5", "88", "244"],
            ["6", "91", "248"],
            ["7", "94", "260"],
            ["8", "96", "269"],
            ["9", "98", "278"],
            ["10", "98", "286"],
            ["11", "100", "294"],
            ["12", "103", "304"]
          ],
          note: "Boat, Loafer"
        },
        "Nature Form Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Nature-Form-Shoe-Donkey_Brown_800x800_a.jpg?v=1740804376&width=600",
          rows: [
            ["2", "83", "217"],
            ["3", "86", "224"],
            ["3.5", "87", "229"],
            ["4", "87", "235"],
            ["4.5", "90", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "253"],
            ["6.5", "92", "257"],
            ["7", "93", "261"],
            ["7.5", "94", "264"],
            ["8", "96", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "278"],
            ["9.5", "99", "281"],
            ["10", "100", "285"],
            ["10.5", "101", "289"],
            ["11", "102", "294"],
            ["12", "103", "303"]
          ],
          note: "Nature Form, Basotho, Beach, Guru, Champal"
        },
        "Strutter Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Strutter-Brown_800x800_a.jpg?v=1740804371&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Navajo, M.Slip-on, Strutter, Wool Tundra"
        },
        "Navajo Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Navajo-Brown_800x800_a.jpg?v=1740804369&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Navajo, M.Slip-on, Strutter, Wool Tundra"
        },
        "Meneer Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Meneer-Chestnut_800x800_a.jpg?v=1740804372&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"],
            ["6.5", "93", "256"],
            ["7", "95", "258"],
            ["7.5", "95", "264"],
            ["8", "95", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "279"],
            ["9.5", "98", "282"],
            ["10", "102", "286"],
            ["10.5", "102", "289"],
            ["11", "104", "294"],
            ["11.5", "107", "299"],
            ["12", "109", "304"],
            ["13", "110", "311"],
            ["14", "110", "319"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Trekker Shoe - Steel Toe": {
          image: "https://groundcover.co.za/cdn/shop/files/Trekker-Shoe-Steel-Toe-Cap-Brown_800x800_a.jpg?v=1740804368&width=600",
          rows: [
            ["5", "88", "238"],
            ["6", "90", "246"],
            ["7", "92", "255"],
            ["8", "93", "263"],
            ["9", "98", "271"],
            ["10", "98", "279"],
            ["11", "100", "289"],
            ["12", "103", "296"]
          ],
          note: "Forrester, Chelsea Steel, Trekker Steel"
        }
      },
      Sandals: {
        "Grandpa Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Grandpa-Chestnut_800x800_a.jpg?v=1740804366&width=600",
          rows: [
            ["6", "90", "248"],
            ["7", "92", "257"],
            ["8", "97", "265"],
            ["9", "97", "272"],
            ["10", "101", "282"],
            ["11", "103", "291"],
            ["12", "105", "300"]
          ],
          note: "Men's Grandpa Sandal"
        },
        "Mule Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Mule-Black_800x800_a.jpg?v=1762410063&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Mfolozi Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Mfolozi-Brown_800x800_a.jpg?v=1740804354&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Palma Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/New-sandals_Tan_800x800_a.jpg?v=1740803995&width=600",
          rows: [
            ["3", "89", "230"],
            ["4", "91", "240"],
            ["5", "93", "245"],
            ["6", "95", "250"],
            ["6.5", "97", "260"],
            ["7", "99", "265"],
            ["8", "100", "270"],
            ["9", "101", "280"],
            ["10", "105", "285"],
            ["11", "107", "290"],
            ["12", "111", "300"],
            ["13", "113", "305"]
          ],
          note: "Palma"
        },
        "Guru Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Guru-Chestnut_800x800_a.jpg?v=1740804361&width=600",
          rows: [
            ["2", "83", "217"],
            ["3", "86", "224"],
            ["3.5", "87", "229"],
            ["4", "87", "235"],
            ["4.5", "90", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "253"],
            ["6.5", "92", "257"],
            ["7", "93", "261"],
            ["7.5", "94", "264"],
            ["8", "96", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "278"],
            ["9.5", "99", "281"],
            ["10", "100", "285"],
            ["10.5", "101", "289"],
            ["11", "102", "294"],
            ["12", "103", "303"]
          ],
          note: "Nature Form, Basotho, Beach, Guru, Champal"
        },
        "Bafana Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Bafana-Brown_800x800_a.jpg?v=1740804355&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Basotho Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Basotho-Chestnut_800x800_a.jpg?v=1740804350&width=600",
          rows: [
            ["2", "83", "217"],
            ["3", "86", "224"],
            ["3.5", "87", "229"],
            ["4", "87", "235"],
            ["4.5", "90", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "253"],
            ["6.5", "92", "257"],
            ["7", "93", "261"],
            ["7.5", "94", "264"],
            ["8", "96", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "278"],
            ["9.5", "99", "281"],
            ["10", "100", "285"],
            ["10.5", "101", "289"],
            ["11", "102", "294"],
            ["12", "103", "303"]
          ],
          note: "Nature Form, Basotho, Beach, Guru, Champal"
        },
        "Champal Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Champal-Chestnut_800x800_a.jpg?v=1740804358&width=990",
          rows: [
            ["2", "83", "217"],
            ["3", "86", "224"],
            ["3.5", "87", "229"],
            ["4", "87", "235"],
            ["4.5", "90", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "253"],
            ["6.5", "92", "257"],
            ["7", "93", "261"],
            ["7.5", "94", "264"],
            ["8", "96", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "278"],
            ["9.5", "99", "281"],
            ["10", "100", "285"],
            ["10.5", "101", "289"],
            ["11", "102", "294"],
            ["12", "103", "303"]
          ],
          note: "Nature Form, Basotho, Beach, Guru, Champal"
        },
        "Ithala Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Ithala-Chestnut_800x800_a.jpg?v=1740804362&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Centurion Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Centurion-Brown_800x800_a.jpg?v=1740804353&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Slide Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Slide-Chestnut_800x800_a.jpg?v=1740804356&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Ceasar Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Ceasar-Brown_800x800_a.jpg?v=1740804351&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        },
        "Nguni Slide": {
          image: "https://groundcover.co.za/cdn/shop/files/Slide-Nguni-Nguni-Blk_Wht_800x800_a.jpg?v=1740804348&width=600",
          rows: [
            ["6", "95", "250"],
            ["7", "95", "258"],
            ["8", "98", "264"],
            ["9", "100", "270"],
            ["10", "100", "278"],
            ["11", "103", "286"],
            ["12", "108", "294"]
          ],
          note: "Bafana, Ceasar, Centurion, Ithala Mfolozi, Mule, Push-in, Slide"
        }
      },
      Winter: {
        "Wool Moccasin": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Moccasin-Adult-Beige_800x800_a.jpg?v=1740804345&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Blizzard Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Blizzard-Boot-Brown_800x800_a.jpg?v=1740804418&width=600",
          rows: [
            ["4", "82", "234"],
            ["4.5", "82", "239"],
            ["5", "87", "243"],
            ["5.5", "87", "248"],
            ["6", "88", "252"],
            ["6.5", "88", "256"],
            ["7", "89", "259"],
            ["7.5", "89", "263"],
            ["8", "91", "269"],
            ["8.5", "92", "273"],
            ["9", "93", "277"],
            ["9.5", "94", "281"],
            ["10", "94", "286"],
            ["10.5", "96", "290"],
            ["11", "97", "294"],
            ["12", "101", "300"],
            ["13", "102", "311"]
          ],
          note: "Wool Blizzard Boot"
        },
        "Wool Slipper": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Slipper-Navy_800x800_a.jpg?v=1740804341&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool High Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-High-Boot-Tan-NB_800x800_a.jpg?v=1740804421&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Stokkie": {
          image: "https://groundcover.co.za/cdn/shop/files/Stokkie_800x800_2.jpg?v=1740804005&width=600",
          rows: [
            ["6", "103", "259"],
            ["6.5", "104", "263"],
            ["7", "105", "267"],
            ["7.5", "106", "272"],
            ["8", "107", "276"],
            ["8.5", "108", "280"],
            ["9", "109", "284"],
            ["9.5", "110", "289"],
            ["10", "111", "293"],
            ["10.5", "113", "297"],
            ["11", "114", "301"],
            ["12", "115", "310"]
          ],
          note: "Stokkie"
        },
        "Wool Ankle Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Ankle-Boot-Adult-TanNB_800x800_a.jpg?v=1740804419&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Winter Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Winer-Boot_800x800_a_85a2de32-4e66-4e93-99f8-99528e7ae7a7.jpg?v=1740804338&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Clog": {
          image: "https://groundcover.co.za/cdn/shop/files/WinterClogsSquare.jpg?v=1740803973&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Tundra": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-Brown_800x800_a.jpg?v=1740804335&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Wool Fold Down": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Fold-down--Tan-NB_800x800_a.jpg?v=1740804400&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Oslo Slipper": {
          image: "https://groundcover.co.za/cdn/shop/files/New-slipper_800x800_d.jpg?v=1747316048&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot, Oslo"
        },
        "Nguni Wool Tundra Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-NguniB_W_800x800_a.jpg?v=1740804393&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        }
      },
      Veldskoen: {
        "Traditional Veldskoen": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Traditional-Brown_800x800_a.jpg?v=1740804414&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"],
            ["6.5", "93", "256"],
            ["7", "95", "258"],
            ["7.5", "95", "264"],
            ["8", "95", "268"],
            ["8.5", "97", "274"],
            ["9", "98", "279"],
            ["9.5", "98", "282"],
            ["10", "102", "286"],
            ["10.5", "102", "289"],
            ["11", "104", "294"],
            ["11.5", "107", "299"],
            ["12", "109", "304"],
            ["13", "110", "311"],
            ["14", "110", "319"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Veldskoen Broadfit": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Suede-FS-Khaki_800x800_a.jpg?v=1740804416&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking"
        },
        "Veldskoen - Full Grain": {
          image: "https://groundcover.co.za/cdn/shop/files/GC_800x800_Full-grain-veliie_b.jpg?v=1778754632&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking"
        },
        "Veldskoen Slim Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/slim-fit-Khaki-Veldskoen_800x800_a.jpg?v=1740804388&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        }
      }
    }
  },
  womens: {
    label: "Women's",
    categories: {
      Boots: {
        "Berg Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Berg-Brown_800x800_a.jpg?v=1740804423&width=600",
          rows: [
            ["3", "84", "222"],
            ["4", "87", "233"],
            ["4.5", "89", "237"],
            ["5", "91", "241"],
            ["5.5", "91", "243"],
            ["6", "91", "249"],
            ["6.5", "91", "251"],
            ["7", "93", "257"],
            ["7.5", "94", "261"],
            ["8", "96", "266"],
            ["8.5", "96", "271"],
            ["9", "98", "274"],
            ["9.5", "98", "278"],
            ["10", "100", "281"],
            ["10.5", "100", "286"],
            ["11", "102", "291"],
            ["11.5", "102", "294"],
            ["12", "102", "299"],
            ["13", "102", "307"]
          ],
          note: "Berg, Trekker"
        },
        "Chelsea Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Chelsea-Black_800x800_a_377214b5-16e4-4ab5-832c-0c8fc1a7e1a3.jpg?v=1778835967&width=600",
          rows: [
            ["3", "74", "215"],
            ["3.5", "74", "218"],
            ["4", "76", "221"],
            ["4.5", "76", "226"],
            ["5", "77", "231"],
            ["5.5", "80", "235"],
            ["6", "81", "239"],
            ["6.5", "82", "244"],
            ["7", "83", "248"],
            ["7.5", "84", "252"],
            ["8", "85", "257"],
            ["8.5", "85", "261"],
            ["9", "86", "266"]
          ],
          note: "Chelsea Boot, Namib, Elf, Takkie"
        },
        "Thuli Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Thuli-OilyBrown_800x800_a.jpg?v=1740804426&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Sabie Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Sabie-boot_800x800_f368f93b-a150-4fb2-b290-7bdfdfe7799a.jpg?v=1778072974&width=600",
          rows: [
            ["4", "86", "230"],
            ["4.5", "87", "234"],
            ["5", "88", "238"],
            ["5.5", "89", "242"],
            ["6", "90", "248"],
            ["6.5", "91", "250"],
            ["7", "92", "256"],
            ["7.5", "94", "259"],
            ["8", "95", "263"],
            ["8.5", "95", "268"],
            ["9", "96", "273"],
            ["9.5", "97", "277"],
            ["10", "97", "281"],
            ["10.5", "98", "285"],
            ["11", "100", "289"],
            ["11.5", "102", "294"],
            ["12", "103", "299"],
            ["13", "105", "307"]
          ],
          note: "Bikers, Desert, M. Combat, Sabie"
        },
        "Berlin Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Berlin-Boot_Navy_800x800_a.jpg?v=1740803960&width=600",
          rows: [
            ["3", "74", "215"],
            ["3.5", "74", "218"],
            ["4", "76", "221"],
            ["4.5", "76", "226"],
            ["5", "77", "231"],
            ["5.5", "80", "235"],
            ["6", "81", "239"],
            ["6.5", "82", "244"],
            ["7", "83", "248"],
            ["7.5", "84", "252"],
            ["8", "85", "257"],
            ["8.5", "85", "261"],
            ["9", "86", "266"]
          ],
          note: "Chelsea Boot, Namib, Elf, Takkie, Berlin"
        },
        "Wool Tamara Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tamara-Donkey-NB_800x800_a.jpg?v=1740804327&width=600",
          rows: [
            ["2", "78", "211"],
            ["2.5", "79", "215"],
            ["3", "79", "222"],
            ["3.5", "80", "224"],
            ["4", "82", "229"],
            ["4.5", "83", "234"],
            ["5", "85", "238"],
            ["5.5", "86", "242"],
            ["6", "88", "245"],
            ["6.5", "89", "250"],
            ["7", "89", "255"],
            ["7.5", "90", "259"],
            ["8", "92", "263"],
            ["9", "94", "265"]
          ],
          note: "Slip-on, Wool Pixie, Wool Tamara"
        },
        "Wool Alpine Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Alpine-Boot_Brown_800x800_a.jpg?v=1740804324&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Alpine Boot (Non-Wool)": {
          image: "https://groundcover.co.za/cdn/shop/files/Alpine_Nowool_-Black_800x800_a.jpg?v=1740804297&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Chukka Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Chukka-Tan_800x800_a.jpg?v=1740804311&width=600",
          rows: [
            ["2", "77", "214"],
            ["2.5", "78", "219"],
            ["3", "79", "223"],
            ["3.5", "80", "228"],
            ["4", "82", "233"],
            ["4.5", "82", "235"],
            ["5", "83", "240"],
            ["5.5", "84", "245"],
            ["6", "86", "249"],
            ["6.5", "87", "254"],
            ["7", "88", "258"],
            ["7.5", "89", "261"],
            ["8", "90", "267"],
            ["8.5", "92", "271"],
            ["9", "92", "276"]
          ],
          note: "Chukka, Karkloof, Walkabout, Clog, Ladies Combat"
        },
        "Walkabout Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Walkabout-Tan_800x800_a.jpg?v=1740804315&width=600",
          rows: [
            ["2", "77", "214"],
            ["2.5", "78", "219"],
            ["3", "79", "223"],
            ["3.5", "80", "228"],
            ["4", "82", "233"],
            ["4.5", "82", "235"],
            ["5", "83", "240"],
            ["5.5", "84", "245"],
            ["6", "86", "249"],
            ["6.5", "87", "254"],
            ["7", "88", "258"],
            ["7.5", "89", "261"],
            ["8", "90", "267"],
            ["8.5", "92", "271"],
            ["9", "92", "276"]
          ],
          note: "Chukka, Karkloof, Walkabout, Clog, Ladies Combat"
        },
        "Karkloof Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Karkloof-Brown_800x800_a.jpg?v=1740804401&width=600",
          rows: [
            ["2", "77", "214"],
            ["2.5", "78", "219"],
            ["3", "79", "223"],
            ["3.5", "80", "228"],
            ["4", "82", "233"],
            ["4.5", "82", "235"],
            ["5", "83", "240"],
            ["5.5", "84", "245"],
            ["6", "86", "249"],
            ["6.5", "87", "254"],
            ["7", "88", "258"],
            ["7.5", "89", "261"],
            ["8", "90", "267"],
            ["8.5", "92", "271"],
            ["9", "92", "276"]
          ],
          note: "Chukka, Karkloof, Walkabout, Clog, Ladies Combat"
        },
        "Namib Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Namib-Brown_800x800_a.jpg?v=1740804304&width=600",
          rows: [
            ["3", "74", "215"],
            ["3.5", "74", "218"],
            ["4", "76", "221"],
            ["4.5", "76", "226"],
            ["5", "77", "231"],
            ["5.5", "80", "235"],
            ["6", "81", "239"],
            ["6.5", "82", "244"],
            ["7", "83", "248"],
            ["7.5", "84", "252"],
            ["8", "85", "257"],
            ["8.5", "85", "261"],
            ["9", "86", "266"]
          ],
          note: "Chelsea Boot, Namib, Elf, Takkie, Berlin"
        },
        "Elf Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Elf-NavyNB_800x800_a.jpg?v=1740804307&width=600",
          rows: [
            ["3", "74", "215"],
            ["3.5", "74", "218"],
            ["4", "76", "221"],
            ["4.5", "76", "226"],
            ["5", "77", "231"],
            ["5.5", "80", "235"],
            ["6", "81", "239"],
            ["6.5", "82", "244"],
            ["7", "83", "248"],
            ["7.5", "84", "252"],
            ["8", "85", "257"],
            ["8.5", "85", "261"],
            ["9", "86", "266"]
          ],
          note: "Chelsea Boot, Namib, Elf, Takkie, Berlin"
        },
        "Veldskoen Broad Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Suede-FS-Khaki_800x800_a.jpg?v=1740804416&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking"
        },
        "Veldskoen Slim Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/slim-fit-Khaki-Veldskoen_800x800_a.jpg?v=1740804388&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Combat Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Combat-Boot-Brown_800x800_a.jpg?v=1740804403&width=600",
          rows: [
            ["2", "77", "214"],
            ["2.5", "78", "219"],
            ["3", "79", "223"],
            ["3.5", "80", "228"],
            ["4", "82", "233"],
            ["4.5", "82", "235"],
            ["5", "83", "240"],
            ["5.5", "84", "245"],
            ["6", "86", "249"],
            ["6.5", "87", "254"],
            ["7", "88", "258"],
            ["7.5", "89", "261"],
            ["8", "90", "267"],
            ["8.5", "92", "271"],
            ["9", "92", "276"]
          ],
          note: "Chukka, Karkloof, Walkabout, Clog, Ladies Combat"
        },
        "Biker Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Bikers-black_800x800_a.jpg?v=1740804394&width=600",
          rows: [
            ["4", "86", "230"],
            ["4.5", "87", "234"],
            ["5", "88", "238"],
            ["5.5", "89", "242"],
            ["6", "90", "248"],
            ["6.5", "91", "250"],
            ["7", "92", "256"],
            ["7.5", "94", "259"],
            ["8", "95", "263"],
            ["8.5", "95", "268"],
            ["9", "96", "273"],
            ["9.5", "97", "277"],
            ["10", "97", "281"],
            ["10.5", "98", "285"],
            ["11", "100", "289"],
            ["11.5", "102", "294"],
            ["12", "103", "299"],
            ["13", "105", "307"]
          ],
          note: "Bikers, Sabie"
        },
        "Wool Blizzard Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Blizzard-Boot-Brown_800x800_a.jpg?v=1740804418&width=600",
          rows: [
            ["4", "82", "234"],
            ["4.5", "82", "239"],
            ["5", "87", "243"],
            ["5.5", "87", "248"],
            ["6", "88", "252"],
            ["6.5", "88", "256"],
            ["7", "89", "259"],
            ["7.5", "89", "263"],
            ["8", "91", "269"],
            ["8.5", "92", "273"],
            ["9", "93", "277"],
            ["9.5", "94", "281"],
            ["10", "94", "286"],
            ["10.5", "96", "290"],
            ["11", "97", "294"],
            ["12", "101", "300"],
            ["13", "102", "311"]
          ],
          note: "Wool Blizzard Boot"
        },
        "Wool Tundra Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-Black_800x800_a_017654ae-224e-4bf3-8af8-5c469e53e4fa.jpg?v=1740804322&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Nguni Wool Tundra Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-NguniB_W_800x800_a.jpg?v=1740804393&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Arctic Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Arctic-Boot-Brown_800x800_a.jpg?v=1740804220&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Wool Pixie Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Pixie-Boot-Black_800x800_a.jpg?v=1740804295&width=600",
          rows: [
            ["2", "78", "211"],
            ["2.5", "79", "215"],
            ["3", "79", "222"],
            ["3.5", "80", "224"],
            ["4", "82", "229"],
            ["4.5", "83", "234"],
            ["5", "85", "238"],
            ["5.5", "86", "242"],
            ["6", "88", "245"],
            ["6.5", "89", "250"],
            ["7", "89", "255"],
            ["7.5", "90", "259"],
            ["8", "92", "263"],
            ["9", "94", "265"]
          ],
          note: "Slip-on, Wool Pixie, Wool Tamara"
        },
        "Wool Winter Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Winer-Boot_800x800_a_85a2de32-4e66-4e93-99f8-99528e7ae7a7.jpg?v=1740804338&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "City Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/City-Black_800x800_a.jpg?v=1740804290&width=600",
          rows: [
            ["3", "77", "218"],
            ["3.5", "77", "221"],
            ["4", "78", "225"],
            ["4.5", "78", "228"],
            ["5", "81", "233"],
            ["5.5", "81", "238"],
            ["6", "81", "242"],
            ["6.5", "81", "247"],
            ["7", "82", "251"],
            ["7.5", "82", "253"],
            ["8", "84", "258"],
            ["9", "87", "267"]
          ],
          note: "City, Mary Jane, Doris"
        },
        "Wool High Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-High-Boot-Tan-NB_800x800_a.jpg?v=1740804421&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Ankle Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Ankle-Boot-Adult-TanNB_800x800_a_47c7e429-8188-44e1-90ad-e03ec2063972.jpg?v=1740804333&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Fold Down Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Fold-down--Tan-NB_800x800_a_2d1ae55c-6559-4c74-8738-5c97b80149b9.jpg?v=1740804305&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Holly Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/GC_800x800_Holly-Donkey_Green_b.jpg?v=1740804291&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        },
        "Veldskoen Full Grain": {
          image: "https://groundcover.co.za/cdn/shop/files/GC_800x800_Full-grain-veliie_b.jpg?v=1778754632&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking"
        }
      },
      Shoes: {
        "Lace-Up Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Lace-up_Brown_800x800_a.jpg?v=1740804284&width=600",
          rows: [
            ["1", "72", "205"],
            ["1.5", "72", "209"],
            ["2", "74", "213"],
            ["2.5", "74", "217"],
            ["3", "77", "220"],
            ["3.5", "78", "226"],
            ["4", "78", "229"],
            ["4.5", "80", "235"],
            ["5", "82", "240"],
            ["5.5", "83", "243"],
            ["6", "83", "247"],
            ["6.5", "84", "252"],
            ["7", "84", "255"],
            ["7.5", "84", "260"],
            ["8", "87", "264"],
            ["8.5", "87", "268"],
            ["9", "87", "273"]
          ],
          note: "Lace up, Pump"
        },
        "Mary-Jane Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/MaryJane-Red_800x800_a.jpg?v=1740804281&width=600",
          rows: [
            ["3", "77", "218"],
            ["3.5", "77", "221"],
            ["4", "78", "225"],
            ["4.5", "78", "228"],
            ["5", "81", "233"],
            ["5.5", "81", "238"],
            ["6", "81", "242"],
            ["6.5", "81", "247"],
            ["7", "82", "251"],
            ["7.5", "82", "253"],
            ["8", "84", "258"],
            ["9", "87", "267"]
          ],
          note: "City, Mary Jane, Doris"
        },
        "Slip-On Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Slip-on_Navy_800x800_a.jpg?v=1740804279&width=600",
          rows: [
            ["2", "78", "211"],
            ["2.5", "79", "215"],
            ["3", "79", "222"],
            ["3.5", "80", "224"],
            ["4", "82", "229"],
            ["4.5", "83", "234"],
            ["5", "85", "238"],
            ["5.5", "86", "242"],
            ["6", "88", "245"],
            ["6.5", "89", "250"],
            ["7", "89", "255"],
            ["7.5", "90", "259"],
            ["8", "92", "263"],
            ["9", "94", "265"]
          ],
          note: "Slip-on, Wool Pixie, Wool Tamara"
        },
        "Pump Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Pump_800x800_a.jpg?v=1740804273&width=600",
          rows: [
            ["1", "72", "205"],
            ["1.5", "72", "209"],
            ["2", "74", "213"],
            ["2.5", "74", "217"],
            ["3", "77", "220"],
            ["3.5", "78", "226"],
            ["4", "78", "229"],
            ["4.5", "80", "235"],
            ["5", "82", "240"],
            ["5.5", "83", "243"],
            ["6", "83", "247"],
            ["6.5", "84", "252"],
            ["7", "84", "255"],
            ["7.5", "84", "260"],
            ["8", "87", "264"],
            ["8.5", "87", "268"],
            ["9", "87", "273"]
          ],
          note: "Lace up, Pump"
        },
        "Boat Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Boat-Tan_Navy_800x800_a.jpg?v=1740804377&width=600",
          rows: [
            ["3", "83", "227"],
            ["4", "86", "235"],
            ["5", "88", "244"],
            ["6", "91", "248"],
            ["7", "94", "260"],
            ["8", "96", "269"],
            ["9", "98", "278"],
            ["10", "98", "286"],
            ["11", "100", "294"],
            ["12", "103", "304"]
          ],
          note: "Boat Shoe"
        },
        "T-Bar Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/T-Bar_Black_800x800_a.jpg?v=1740804271&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        },
        "Clog Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Clog-Tan_800x800_a.jpg?v=1740804006&width=600",
          rows: [
            ["2", "77", "214"],
            ["2.5", "78", "219"],
            ["3", "79", "223"],
            ["3.5", "80", "228"],
            ["4", "82", "233"],
            ["4.5", "82", "235"],
            ["5", "83", "240"],
            ["5.5", "84", "245"],
            ["6", "86", "249"],
            ["6.5", "87", "254"],
            ["7", "88", "258"],
            ["7.5", "89", "261"],
            ["8", "90", "267"],
            ["8.5", "92", "271"],
            ["9", "92", "276"]
          ],
          note: "Chukka, Karkloof, Walkabout, Clog, Ladies Combat"
        },
        "Walking Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/WalkingShoe-Chestnut_Green_800x800_a.jpg?v=1740804385&width=600",
          rows: [
            ["2", "80", "216"],
            ["2.5", "81", "221"],
            ["3", "81", "224"],
            ["3.5", "82", "230"],
            ["4", "84", "233"],
            ["4.5", "86", "238"],
            ["5", "86", "242"],
            ["5.5", "87", "246"],
            ["6", "86", "250"],
            ["6.5", "89", "253"],
            ["7", "91", "259"],
            ["7.5", "92", "263"],
            ["8", "93", "267"],
            ["8.5", "94", "271"],
            ["9", "96", "275"],
            ["9.5", "96", "279"],
            ["10", "98", "284"],
            ["10.5", "98", "288"],
            ["11", "98", "293"],
            ["11.5", "102", "298"],
            ["12", "102", "301"],
            ["13", "103", "310"]
          ],
          note: "Walking"
        },
        "Broad Fit Walking Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/WalkingShoeFS-Chestnut_800x800_a_ace60be1-ea1c-4393-8500-df8dd7fd392c.jpg?v=1740804268&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking Broadfit"
        },
        "Chelsea Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/ChelseaShoe-Brown_800x800_a.jpg?v=1740804269&width=600",
          rows: [
            ["2", "73", "205"],
            ["3", "74", "214"],
            ["3.5", "74", "218"],
            ["4", "76", "224"],
            ["4.5", "77", "227"],
            ["5", "77", "230"],
            ["5.5", "78", "235"],
            ["6", "80", "241"],
            ["6.5", "81", "244"],
            ["7", "83", "248"],
            ["7.5", "83", "252"],
            ["8", "85", "256"],
            ["8.5", "85", "260"]
          ],
          note: "Chelsea Shoe"
        },
        "Tyrol Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Tyrol-RedSuede_800x800_a.jpg?v=1740804262&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        }
      },
      Sandals: {
        "Daisy Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/DaisyStripper_800x800_a.jpg?v=1740804260&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        },
        "Grandpa Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Grandpa-Chestnut_800x800_a.jpg?v=1740804366&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        },
        "Toe Strap Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Toe-Strap_800x800_a.jpg?v=1740804253&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Palma Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/New-sandals_Tan_800x800_a.jpg?v=1740803995&width=600",
          rows: [
            ["3", "89", "230"],
            ["4", "91", "240"],
            ["5", "93", "245"],
            ["6", "95", "250"],
            ["6.5", "97", "260"],
            ["7", "99", "265"],
            ["8", "100", "270"],
            ["9", "101", "280"],
            ["10", "105", "285"],
            ["11", "107", "290"],
            ["12", "111", "300"],
            ["13", "113", "305"]
          ],
          note: "Palma"
        },
        "Sandy Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Sandy_800x800_a.jpg?v=1740804251&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Slop": {
          image: "https://groundcover.co.za/cdn/shop/files/Slop-brown_800x800_a.jpg?v=1740804250&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Broad-strap Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Broadstrap-Navy_800x800_a.jpg?v=1740804246&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Guru Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Guru-Chestnut_800x800_a.jpg?v=1740804361&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Champal Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Champal_800x800_a.jpg?v=1740804243&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Andes Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Andes_800x800_a.jpg?v=1740804242&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        },
        "Princess Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Princess_800x800_a.jpg?v=1740804241&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Zapata Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Zapata_800x800_a.jpg?v=1740804239&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Crocket Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Crockett_800x800_a.jpg?v=1740804238&width=600",
          rows: [
            ["2", "74", "208"],
            ["2.5", "75", "212"],
            ["3", "76", "218"],
            ["3.5", "78", "222"],
            ["4", "79", "226"],
            ["4.5", "81", "231"],
            ["5", "81", "235"],
            ["5.5", "83", "239"],
            ["6", "83", "243"],
            ["6.5", "85", "247"],
            ["7", "86", "252"],
            ["7.5", "86", "255"],
            ["8", "87", "260"],
            ["8.5", "88", "264"],
            ["9", "88", "267"]
          ],
          note: "T-Bar, Tyrol, Andes, Crocket, Daisy, Grandpa, Holly"
        },
        "Sakabula Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Sakabula_800x800_a.jpg?v=1740804234&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Capri Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Capri-Black_800x800_a.jpg?v=1740804237&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Jacana Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/GC_800x800_a.jpg?v=1740804235&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Lucky Penny Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/LuckyPenny-Tan_800x800_a.jpg?v=1740804245&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Heidi Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Heidi_800x800_a.jpg?v=1740804233&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Kate Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Kate-Black_800x800_a.jpg?v=1740804232&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "DÃ©jÃ  Vu Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Deja-Vu_800x800_a.jpg?v=1740804231&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        },
        "Tomwin Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Tomwin-Chestnut_800x800_a.jpg?v=1740804230&width=600",
          rows: [
            ["2", "80", "211"],
            ["3", "81", "220"],
            ["4", "84", "227"],
            ["5", "87", "235"],
            ["6", "89", "245"],
            ["7", "92", "253"],
            ["8", "97", "262"],
            ["9", "97", "270"]
          ],
          note: "Broadstrap, Champal, Dejavu, Guru, Kate,, Princess, Sandy,  Slop, Toe strap, Tomwin, Zapata"
        }
      },
      Winter: {
        "Wool Moccasin": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Moccasin-Adult-Beige_800x800_a.jpg?v=1740804345&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Arctic Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Arctic-Boot-Brown_800x800_a.jpg?v=1740804220&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        },
        "Wool Tamara Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tamara-Donkey-NB_800x800_a.jpg?v=1740804327&width=600",
          rows: [
            ["2", "78", "211"],
            ["2.5", "79", "215"],
            ["3", "79", "222"],
            ["3.5", "80", "224"],
            ["4", "82", "229"],
            ["4.5", "83", "234"],
            ["5", "85", "238"],
            ["5.5", "86", "242"],
            ["6", "88", "245"],
            ["6.5", "89", "250"],
            ["7", "89", "255"],
            ["7.5", "90", "259"],
            ["8", "92", "263"],
            ["9", "94", "265"]
          ],
          note: "Slip-on, Wool Pixie, Wool Tamara"
        },
        "Wool Alpine Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Alpine-Boot_Brown_800x800_a.jpg?v=1740804324&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Wool Blizzard Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Blizzard-Boot-Brown_800x800_a.jpg?v=1740804418&width=600",
          rows: [
            ["4", "82", "234"],
            ["4.5", "82", "239"],
            ["5", "87", "243"],
            ["5.5", "87", "248"],
            ["6", "88", "252"],
            ["6.5", "88", "256"],
            ["7", "89", "259"],
            ["7.5", "89", "263"],
            ["8", "91", "269"],
            ["8.5", "92", "273"],
            ["9", "93", "277"],
            ["9.5", "94", "281"],
            ["10", "94", "286"],
            ["10.5", "96", "290"],
            ["11", "97", "294"],
            ["12", "101", "300"],
            ["13", "102", "311"]
          ],
          note: "Wool Blizzard Boot"
        },
        "Wool Tundra Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-Black_800x800_a_017654ae-224e-4bf3-8af8-5c469e53e4fa.jpg?v=1740804322&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Wool Slipper": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Slipper-Navy_800x800_a.jpg?v=1740804341&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Insole Clog": {
          image: "https://groundcover.co.za/cdn/shop/files/WinterClogsSquare_540547a1-5e3a-4b53-8559-771535629f91.jpg?v=1740803972&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Winter Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Winer-Boot_800x800_a_85a2de32-4e66-4e93-99f8-99528e7ae7a7.jpg?v=1740804338&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool Ankle Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Ankle-Boot-Adult-TanNB_800x800_a.jpg?v=1740804419&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Wool High Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-High-Boot-Tan-NB_800x800_a.jpg?v=1740804421&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot"
        },
        "Stokkie": {
          image: "https://groundcover.co.za/cdn/shop/files/Stokkie_800x800_2.jpg?v=1740804005&width=600",
          rows: [
            ["6", "103", "259"],
            ["6.5", "104", "263"],
            ["7", "105", "267"],
            ["7.5", "106", "272"],
            ["8", "107", "276"],
            ["8.5", "108", "280"],
            ["9", "109", "284"],
            ["9.5", "110", "289"],
            ["10", "111", "293"],
            ["10.5", "113", "297"],
            ["11", "114", "301"],
            ["12", "115", "310"]
          ],
          note: "Stokkie"
        },
        "Oslo Wool Slipper": {
          image: "https://groundcover.co.za/cdn/shop/files/New-slipper_800x800_d.jpg?v=1747316048&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot, Oslo"
        },
        "Wool Fold-Down Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Fold-down--Tan-NB_800x800_a.jpg?v=1740804400&width=600",
          rows: [
            ["3", "83", "225"],
            ["4", "85", "232"],
            ["5", "88", "240"],
            ["6", "90", "249"],
            ["7", "93", "259"],
            ["8", "93", "266"],
            ["9", "96", "275"],
            ["10", "98", "284"],
            ["11", "100", "292"],
            ["12", "103", "302"],
            ["13", "106", "309"]
          ],
          note: "Clog, Wool Ankle, Wool Fold Down, Wool High boot, Gc wool  Moccassin, Wool Slipper, Winter boot, Oslo"
        },
        "Wool Pixie Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Pixie-Boot-Black_800x800_a.jpg?v=1740804295&width=600",
          rows: [
            ["2", "78", "211"],
            ["2.5", "79", "215"],
            ["3", "79", "222"],
            ["3.5", "80", "224"],
            ["4", "82", "229"],
            ["4.5", "83", "234"],
            ["5", "85", "238"],
            ["5.5", "86", "242"],
            ["6", "88", "245"],
            ["6.5", "89", "250"],
            ["7", "89", "255"],
            ["7.5", "90", "259"],
            ["8", "92", "263"],
            ["9", "94", "265"]
          ],
          note: "Slip-on, Wool Pixie, Wool Tamara"
        },
        "Wool Nguni Tundra": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Tundra-Boot-NguniB_W_800x800_a_a6552041-acd4-4dc5-ae35-2d7d382b0365.jpg?v=1740804289&width=600",
          rows: [
            ["6", "96", "254"],
            ["7", "98", "262"],
            ["8", "98", "268"],
            ["9", "100", "275"],
            ["10", "102", "283"],
            ["11", "103", "288"],
            ["12", "106", "296"]
          ],
          note: "Wool Tundra"
        },
        "Wool Arctic Nguni Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/WoolArcticBoot_NguniB_W_800x800_a.jpg?v=1740804302&width=600",
          rows: [
            ["3", "75", "216"],
            ["4", "76", "221"],
            ["5", "79", "229"],
            ["6", "82", "236"],
            ["7", "83", "242"],
            ["8", "85", "249"],
            ["9", "87", "256"]
          ],
          note: "Capri,Heidi, Jacana, Lucky Penny, Sakabula, Arctic"
        }
      },
      Veldskoen: {
        "Elf Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Elf-NavyNB_800x800_a.jpg?v=1740804307&width=600",
          rows: [
            ["3", "74", "215"],
            ["3.5", "74", "218"],
            ["4", "76", "221"],
            ["4.5", "76", "226"],
            ["5", "77", "231"],
            ["5.5", "80", "235"],
            ["6", "81", "239"],
            ["6.5", "82", "244"],
            ["7", "83", "248"],
            ["7.5", "84", "252"],
            ["8", "85", "257"],
            ["8.5", "85", "261"],
            ["9", "86", "266"]
          ],
          note: "Chelsea Boot, Namib, Elf, Takkie, Berlin"
        },
        "Veldskoen Broad Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Suede-FS-Khaki_800x800_a.jpg?v=1740804416&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking"
        },
        "Veldskoen Slim Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/slim-fit-Khaki-Veldskoen_800x800_a.jpg?v=1740804388&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"],
            ["7", "88", "266"],
            ["7.5", "89", "271"],
            ["8", "90", "274"],
            ["8.5", "92", "278"],
            ["9", "93", "283"],
            ["9.5", "95", "286"],
            ["10", "95", "291"],
            ["10.5", "98", "298"],
            ["11", "99", "301"],
            ["11.5", "100", "304"],
            ["12", "100", "308"],
            ["12.5", "101", "313"],
            ["13", "102", "316"]
          ],
          note: "Veldskoen Slim Fit, Alpine (Wool & Non-Wool), Thuli, Oliver"
        },
        "Veldskoen Broad Fit Full Grain": {
          image: "https://groundcover.co.za/cdn/shop/files/GC_800x800_Full-grain-veliie_b.jpg?v=1778754632&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"],
            ["6.5", "92", "255"],
            ["7", "93", "260"],
            ["7.5", "94", "264"],
            ["8", "94", "269"],
            ["8.5", "95", "272"],
            ["9", "98", "276"],
            ["9.5", "98", "280"],
            ["10", "99", "284"],
            ["10.5", "101", "289"],
            ["11", "104", "293"],
            ["11.5", "105", "296"],
            ["12", "105", "300"],
            ["13", "105", "307"],
            ["14", "108", "314"]
          ],
          note: "Veldskoen Broadfit, Walking"
        }
      }
    }
  },
  childrens: {
    label: "Kids",
    categories: {
      Boots: {
        "Youth Chelsea Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Youth-cheslea_brown_800x800_a.jpg?v=1740804219&width=600",
          rows: [
            ["3", "74", "215"],
            ["3.5", "74", "218"],
            ["4", "76", "221"],
            ["4.5", "76", "226"],
            ["5", "77", "231"],
            ["5.5", "80", "235"],
            ["6", "81", "239"]
          ],
          note: "Youth Chelsea Boot"
        },
        "Children's Chelsea Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Chelsea-Boot-Brown_800x800_a_b6507557-6e9a-4c65-a175-1813d1696d33.jpg?v=1740804212&width=600",
          rows: [
            ["8", "65", "160"],
            ["9", "66", "168"],
            ["10", "67", "176"],
            ["11", "70", "185"],
            ["12", "71", "195"],
            ["13", "72", "203"],
            ["1", "77", "211"],
            ["2", "77", "220"]
          ],
          note: "Childrens Chelsea, Childrens Land Boot"
        },
        "Youth Land Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Land-Boot-Tan_800x800_a.jpg?v=1740804216&width=600",
          rows: [
            ["3", "85", "226"],
            ["3.5", "86", "231"],
            ["4", "87", "234"],
            ["4.5", "89", "239"],
            ["5", "90", "244"],
            ["5.5", "91", "248"],
            ["6", "92", "251"]
          ],
          note: "Dirt Road, Land, Stockman, Traditional Veldskoen, Meneer"
        },
        "Chldren's Land Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Land-Boot-Tan_800x800_a_5e740720-d62d-431c-8243-196ccc605a9e.jpg?v=1740804207&width=600",
          rows: [
            ["8", "65", "160"],
            ["9", "66", "168"],
            ["10", "67", "176"],
            ["11", "70", "185"],
            ["12", "71", "195"],
            ["13", "72", "203"],
            ["1", "77", "211"],
            ["2", "77", "220"]
          ],
          note: "Childrens Chelsea, Childrens Land Boot"
        },
        "Youth Thuli Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Thuli-Oily-Brown_800x800_a-3.jpg?v=1740804213&width=600",
          rows: [
            ["2", "80", "225"],
            ["3", "81", "234"],
            ["3.5", "82", "238"],
            ["4", "83", "241"],
            ["4.5", "83", "246"],
            ["5", "85", "249"],
            ["5.5", "86", "254"],
            ["6", "87", "258"],
            ["6.5", "88", "261"]
          ],
          note: "Thuli"
        }
      },
      Shoes: {
        "Children's T-Bar Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/T-bar-Black-_800x800_a.jpg?v=1740804203&width=600",
          rows: [
            ["8", "66", "155"],
            ["9", "67", "163"],
            ["10", "67", "171"],
            ["11", "69", "181"],
            ["12", "71", "187"],
            ["13", "72", "198"],
            ["1", "74", "207"]
          ],
          note: "T-Bar, Veldskoen"
        },
        "Youth Walking Shoe": {
          image: "https://groundcover.co.za/cdn/shop/files/Walking-Shoe-ChestnutGreen_800x800_a.jpg?v=1740804214&width=600",
          rows: [
            ["2", "80", "216"],
            ["2.5", "81", "221"],
            ["3", "81", "224"],
            ["3.5", "82", "230"],
            ["4", "84", "233"],
            ["4.5", "86", "238"],
            ["5", "86", "242"],
            ["5.5", "87", "246"],
            ["6", "86", "250"],
            ["6.5", "89", "253"]
          ],
          note: "Oxford, Walking"
        }
      },
      Sandals: {
        "Children's Tomwin Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Tomwin-Black_800x800_a_35793733-4186-4fa0-ab57-9c4058db3655.jpg?v=1740803975&width=600",
          rows: [
            ["8", "64", "162"],
            ["9", "65", "169"],
            ["10", "66", "177"],
            ["11", "68", "185"],
            ["12", "69", "194"],
            ["13", "71", "203"],
            ["1", "72", "212"],
            ["2", "74", "220"]
          ],
          note: "Grandpa, Sandy, Tomwin, Wool Moc"
        },
        "Infant Daisy Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Daisy-Stripper_800x800_a.jpg?v=1740804200&width=600",
          rows: [
            ["3", "55", "122"],
            ["4", "57", "132"],
            ["5", "58", "139"],
            ["6", "59", "147"],
            ["7", "61", "155"],
            ["8", "61", "163"]
          ],
          note: "All Infant"
        },
        "Children's Grandpa Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Grandpa-Chestnut_800x800_a_fa8e9eef-82cf-4e61-a994-346dca28e055.jpg?v=1740804205&width=600",
          rows: [
            ["8", "64", "162"],
            ["9", "65", "169"],
            ["10", "66", "177"],
            ["11", "68", "185"],
            ["12", "69", "194"],
            ["13", "71", "203"],
            ["1", "72", "212"],
            ["2", "74", "220"]
          ],
          note: "Grandpa, Sandy, Tomwin, Wool Moc"
        },
        "Infant Grandpa Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Grandpa-Chestnut_800x800_a-3.jpg?v=1740804199&width=600",
          rows: [
            ["3", "55", "122"],
            ["4", "57", "132"],
            ["5", "58", "139"],
            ["6", "59", "147"],
            ["7", "61", "155"],
            ["8", "61", "163"]
          ],
          note: "All Infant"
        },
        "Children's Sandy Sandal": {
          image: "https://groundcover.co.za/cdn/shop/files/Sandy-Chestnut_800x800_a.jpg?v=1740804204&width=600",
          rows: [
            ["8", "64", "162"],
            ["9", "65", "169"],
            ["10", "66", "177"],
            ["11", "68", "185"],
            ["12", "69", "194"],
            ["13", "71", "203"],
            ["1", "72", "212"],
            ["2", "74", "220"]
          ],
          note: "Grandpa, Sandy, Tomwin, Wool Moc"
        }
      },
      Winter: {
        "Infant Lapland Slipper": {
          image: "https://groundcover.co.za/cdn/shop/files/Kids-slipper_800x800_e.jpg?v=1778080143&width=600",
          rows: [
            ["3", "55", "122"],
            ["4", "57", "132"],
            ["5", "58", "139"],
            ["6", "59", "147"],
            ["7", "61", "155"],
            ["8", "61", "163"]
          ],
          note: "All Infant"
        },
        "Children's Wool Moccasin": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Moccasin-Kids-Beige_800x800_a.jpg?v=1740804211&width=600",
          rows: [
            ["8", "64", "162"],
            ["9", "65", "169"],
            ["10", "66", "177"],
            ["11", "68", "185"],
            ["12", "69", "194"],
            ["13", "71", "203"],
            ["1", "72", "212"],
            ["2", "74", "220"]
          ],
          note: "Grandpa, Sandy, Tomwin, Wool Moc"
        },
        "Infant Wool Ankle Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Ankle-Boot---Infant_s_800x800_Tan-NB_a.jpg?v=1740804198&width=600",
          rows: [
            ["3", "55", "122"],
            ["4", "57", "132"],
            ["5", "58", "139"],
            ["6", "59", "147"],
            ["7", "61", "155"],
            ["8", "61", "163"]
          ],
          note: "All Infant"
        },
        "Children's Wool Ankle Boot": {
          image: "https://groundcover.co.za/cdn/shop/files/Wool-Ankle-Boot---Kid_s_800x800-Tan-Nb_b.jpg?v=1740804209&width=600",
          rows: [
            ["8", "64", "162"],
            ["9", "65", "169"],
            ["10", "66", "177"],
            ["11", "68", "185"],
            ["12", "69", "194"],
            ["13", "71", "203"],
            ["1", "72", "212"],
            ["2", "74", "220"]
          ],
          note: "Grandpa, Sandy, Tomwin, Wool Moc"
        }
      },
      Veldskoen: {
        "Youth Veldskoen Broad Fit": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Khaki-Suede_800x800_a.jpg?v=1740804218&width=600",
          rows: [
            ["2", "83", "218"],
            ["2.5", "85", "223"],
            ["3", "85", "228"],
            ["3.5", "86", "232"],
            ["4", "89", "237"],
            ["4.5", "90", "241"],
            ["5", "90", "245"],
            ["5.5", "91", "249"],
            ["6", "91", "251"]
          ],
          note: "Veldskoen Broadfit"
        },
        "Children's Veldskoen": {
          image: "https://groundcover.co.za/cdn/shop/files/Velskoen-Khaki-Suede_800x800_a_463aad02-3770-4feb-ae97-c1bcda9d8aac.jpg?v=1740804208&width=600",
          rows: [
            ["8", "66", "155"],
            ["9", "67", "163"],
            ["10", "67", "171"],
            ["11", "69", "181"],
            ["12", "71", "187"],
            ["13", "72", "198"],
            ["1", "74", "207"]
          ],
          note: "T-Bar, Veldskoen"
        },
        "Infant Veldskoen": {
          image: "https://groundcover.co.za/cdn/shop/files/Infant-Vellie-Khaki_800x800_a.jpg?v=1740804202&width=600",
          rows: [
            ["3", "55", "122"],
            ["4", "57", "132"],
            ["5", "58", "139"],
            ["6", "59", "147"],
            ["7", "61", "155"],
            ["8", "61", "163"]
          ],
          note: "All Infant"
        }
      }
    }
  }
};

class SizingGuide {
  constructor(sectionId) {
    this.id       = sectionId;
    this.gender   = null;
    this.category = null;
    this.item     = null;

    this.el = {
      breadcrumb : document.getElementById(`sg-breadcrumb-${sectionId}`),
      step1      : document.getElementById(`sg-step1-${sectionId}`),
      step2      : document.getElementById(`sg-step2-${sectionId}`),
      step3      : document.getElementById(`sg-step3-${sectionId}`),
      catPills   : document.getElementById(`sg-cats-${sectionId}`),
      itemGrid   : document.getElementById(`sg-items-${sectionId}`),
      back       : document.getElementById(`sg-back-${sectionId}`),
      guideTitle : document.getElementById(`sg-guide-title-${sectionId}`),
      guideSub   : document.getElementById(`sg-guide-sub-${sectionId}`),
      table      : document.getElementById(`sg-table-${sectionId}`),
      note       : document.getElementById(`sg-note-${sectionId}`)
    };

    this._bindGenderPills();
    this.el.back.addEventListener("click", () => this._backToStep2());

    /* Deep-link: auto-navigate if URL params are present */
    this._handleDeepLink();
  }

  /* â”€â”€ Deep-link â”€â”€ */
  _handleDeepLink() {
    const params   = new URLSearchParams(window.location.search);
    const gender   = params.get("sg_gender");
    const category = params.get("sg_category");
    const item     = params.get("sg_item");

    if (!gender || !SIZING_DATA[gender]) return;
    if (!category || !SIZING_DATA[gender].categories[category]) return;

    this._selectGender(gender);
    this._selectCategory(category);

    if (item && SIZING_DATA[gender].categories[category][item]) {
      this._selectItem(item);
      setTimeout(() => {
        const section = document.getElementById(`sizing-guide-${this.id}`);
        if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }

  /* â”€â”€ Gender â”€â”€ */
  _bindGenderPills() {
    this.el.step1.querySelectorAll(".sg-pill").forEach(btn => {
      btn.addEventListener("click", () => this._selectGender(btn.dataset.gender));
    });
  }

  _selectGender(key) {
    this.gender   = key;
    this.category = null;
    this.item     = null;

    this.el.step1.querySelectorAll(".sg-pill").forEach(btn => {
      const active = btn.dataset.gender === key;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.classList.toggle("is-active", active);
    });

    const cats = Object.keys(SIZING_DATA[key].categories);
    this.category = cats[0];
    this._renderCategoryPills(cats);
    this._renderItemGrid();
    this._showStep(2);
    this._updateBreadcrumb();
  }

  /* â”€â”€ Category â”€â”€ */
  _renderCategoryPills(cats) {
    this.el.catPills.innerHTML = cats.map(cat => `
      <button
        class="sg-pill${cat === this.category ? " is-active" : ""}"
        data-category="${this._esc(cat)}"
        aria-pressed="${cat === this.category ? "true" : "false"}"
      >${this._esc(cat)}</button>
    `).join("");

    this.el.catPills.querySelectorAll(".sg-pill").forEach(btn => {
      btn.addEventListener("click", () => this._selectCategory(btn.dataset.category));
    });
  }

  _selectCategory(cat) {
    this.category = cat;
    this.item     = null;

    this.el.catPills.querySelectorAll(".sg-pill").forEach(btn => {
      const active = btn.dataset.category === cat;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.classList.toggle("is-active", active);
    });

    this._renderItemGrid();
    this._updateBreadcrumb();
  }

  /* â”€â”€ Items â”€â”€ */
  _renderItemGrid() {
    const items = Object.keys(SIZING_DATA[this.gender].categories[this.category]);

    this.el.itemGrid.innerHTML = items.map(name => {
      const guide = SIZING_DATA[this.gender].categories[this.category][name];

      const thumb = guide.image
        ? `<span class="sg-item-card__thumb">
             <img
               src="${this._esc(guide.image)}"
               alt=""
               loading="lazy"
               width="160"
               height="160"
               onerror="this.parentElement.classList.add('sg-item-card__thumb--empty'); this.remove();"
             >
           </span>`
        : `<span class="sg-item-card__thumb sg-item-card__thumb--empty" aria-hidden="true">
             <svg viewBox="0 0 32 32" fill="none">
               <rect x="4" y="8" width="24" height="16" rx="2" stroke="currentColor" stroke-width="1.2" stroke-dasharray="3 2"/>
               <path d="M4 20l6-5 5 4 4-3 9 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
             </svg>
           </span>`;

      return `
        <button
          class="sg-item-card"
          data-item="${this._esc(name)}"
          aria-label="View sizing guide for ${this._esc(name)}"
        >
          ${thumb}
          <span class="sg-item-card__body">
            <span class="sg-item-card__name">${this._esc(name)}</span>
          </span>
        </button>
      `;
    }).join("");

    this.el.itemGrid.querySelectorAll(".sg-item-card").forEach(card => {
      card.addEventListener("click", () => this._selectItem(card.dataset.item));
    });
  }

  /* â”€â”€ Table â”€â”€ */
  _selectItem(name) {
    this.item = name;
    const guide       = SIZING_DATA[this.gender].categories[this.category][name];
    const genderLabel = SIZING_DATA[this.gender].label;

    this.el.guideTitle.textContent = `${genderLabel} / ${this.category} / ${name}`;
    this.el.guideSub.textContent   = `Sizes available: ${guide.rows[0][0]} to ${guide.rows[guide.rows.length - 1][0]}`;
    this.el.note.textContent       = guide.note ? `Additional Applicable Styles: ${guide.note}` : "";

    const thead = `<thead><tr>${SG_COLS.map(c => `<th scope="col">${this._esc(c)}</th>`).join("")}</tr></thead>`;
    const tbody = `<tbody>${guide.rows.map(r =>
      `<tr>${r.map(cell => `<td>${this._esc(cell)}</td>`).join("")}</tr>`
    ).join("")}</tbody>`;

    this.el.table.innerHTML = `<table class="sg-table" aria-label="${this._esc(name)} size chart">${thead}${tbody}</table>`;

    this._showStep(3);
    this._updateBreadcrumb();
  }

  /* â”€â”€ Back â”€â”€ */
  _backToStep2() {
    this.item = null;
    this._showStep(2);
    this._updateBreadcrumb();
  }

  /* â”€â”€ Step visibility â”€â”€ */
  _showStep(n) {
    [2, 3].forEach(i => {
      const el = this.el[`step${i}`];
      el.classList.toggle("sg-step--hidden", i !== n);
      el.setAttribute("aria-hidden", i !== n ? "true" : "false");
    });
  }

  /* â”€â”€ Breadcrumb â”€â”€ */
  _updateBreadcrumb() {
    const parts = [`<span class="sg-breadcrumb__root">Sizing guides</span>`];
    if (this.gender) {
      parts.push(`<span class="sg-breadcrumb__sep" aria-hidden="true">/</span>`);
      parts.push(`<span class="sg-breadcrumb__crumb">${this._esc(SIZING_DATA[this.gender].label)}</span>`);
    }
    if (this.category) {
      parts.push(`<span class="sg-breadcrumb__sep" aria-hidden="true">/</span>`);
      parts.push(`<span class="sg-breadcrumb__crumb">${this._esc(this.category)}</span>`);
    }
    if (this.item) {
      parts.push(`<span class="sg-breadcrumb__sep" aria-hidden="true">/</span>`);
      parts.push(`<span class="sg-breadcrumb__crumb">${this._esc(this.item)}</span>`);
    }
    this.el.breadcrumb.innerHTML = parts.join(" ");
  }

  /* â”€â”€ Utility â”€â”€ */
  _esc(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
}

/* â”€â”€â”€ Initialise â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */

function initSizingGuides() {
  if (!window.SizingGuideConfig) return;
  Object.keys(window.SizingGuideConfig).forEach(id => {
    if (!document.getElementById(`sg-step1-${id}`)) return;
    new SizingGuide(id);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSizingGuides);
} else {
  initSizingGuides();
}

document.addEventListener("shopify:section:load", (e) => {
  const id = e.detail.sectionId;
  if (window.SizingGuideConfig && window.SizingGuideConfig[id]) {
    new SizingGuide(id);
  }
});